/**
 * Theme manager — dark/light com prefers-color-scheme como default.
 * Persiste em localStorage. Aplicação no <html> é feita em index.html
 * (antes do React montar) pra evitar flash.
 */

type Tema = 'light' | 'dark';

export const theme = {
  current(): Tema {
    const saved = localStorage.getItem('theme') as Tema | null;
    if (saved === 'dark' || saved === 'light') return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  },
  apply(t: Tema) {
    document.documentElement.classList.toggle('dark', t === 'dark');
    localStorage.setItem('theme', t);
  },
  toggle() {
    this.apply(this.current() === 'dark' ? 'light' : 'dark');
  },
};
